import React from "react";

// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";

import CardAvatar from "components/Card/CardAvatar.js";
// @material-ui/icons

import Close from "@material-ui/icons/Close";
import Info from "@material-ui/icons/Info";

// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "components/CustomButtons/Button.js";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";

import ReactTable from "components/ReactTable/ReactTable.js";
import PropTypes from "prop-types";

import Slide from "@material-ui/core/Slide";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";

import { cardTitle } from "assets/jss/material-dashboard-pro-react.js";

import stylesAlert from "assets/jss/material-dashboard-pro-react/views/sweetAlertStyle.js";
import stylesModal from "assets/jss/material-dashboard-pro-react/views/notificationsStyle.js";

import axios from "axios";

axios.defaults.withCredentials = true;

const stylesCard = {
  cardIconTitle: {
    ...cardTitle,
    marginTop: "15px",
    marginBottom: "0px",
    textAlign: "left",
  },
};

const stylesList = {
  list: {
    display: "inline",
    padding: "5px",
  },
};

const useStylesAlert = makeStyles(stylesAlert);

const useStylesModal = makeStyles(stylesModal);

const useStylesCard = makeStyles(stylesCard);
const useStylesList = makeStyles(stylesList);

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});

export default function MemberDirectory(props) {
  const classesModal = useStylesModal();
  const classesCard = useStylesCard();
  const classesList = useStylesList();
  const classesAlert = useStylesAlert();

  const classes = {
    ...classesModal,
    ...classesCard,
    ...classesList,
    ...classesAlert,
  };

  const [name, setName] = React.useState("");
  const [institution, setInstitution] = React.useState("");
  const [about, setAbout] = React.useState("");
  const [image, setImage] = React.useState("");

  const [studies, setStudies] = React.useState([]);
  const [recentStudies, setRecentStudies] = React.useState([]);

  const [infoModal, setInfoModal] = React.useState(false);

  const userData = props.members.map((prop) => {
    return {
      id: prop.id,
      email: prop.email,
      type: prop.type,
      name: prop.name,
      institution: prop.institution,
      about: prop.about,
      verified_pubs: prop.verified_pubs,
      actions: (
        // we've added some custom button actions
        <div className="actions-right">
          {/* use this button to add a like kind of action */}
          {/* use this button to add a edit kind of action */}
          <Button
            justIcon
            round
            simple
            onClick={() => {
              clearData();
              const findEmailIndex = ({ email }) => {
                return email == prop.email;
              };

              const emailIndex = props.members.findIndex(findEmailIndex);

              const userData = props.members[emailIndex];

              const filteredStudies = props.studies.filter(function (study) {
                return (
                  prop.verified_pubs && prop.verified_pubs.includes(study.uid)
                );
              });

              userData.studies = filteredStudies.length;

              const studiesWithDate = filteredStudies.map((study) => {
                const withDate = { ...study, date: new Date(study.date) };

                return withDate;
              });

              const arrangedStudies = studiesWithDate.sort(
                (a, b) => b.date - a.date
              );

              const recentStudies = arrangedStudies.slice(0, 5);

              userData.recentStudies = recentStudies;

              const userImage = props.images.filter((file) => {
                //const fileExt = file.split(".").pop();

                return file.includes("profile___" + prop.id + "___");
              });

              userData.userImage = userImage[0];

              addData(userData);

              setInfoModal(true);
            }}
            color="info"
            className="remove"
          >
            <Info />
          </Button>
        </div>
      ),
    };
  });

  const addData = (userData) => {
    userData.name && setName(userData.name);
    userData.institution && setInstitution(userData.institution);
    userData.about && setAbout(userData.about);
    userData.studies && setStudies(userData.studies);
    userData.recentStudies && setRecentStudies(userData.recentStudies);
    userData.userImage && setImage(userData.userImage);
  };

  const clearData = () => {
    setName("");
    setInstitution("");
    setAbout("");
    setStudies([]);
    setImage("");
  };

  return (
    <div>
      {alert}
      <Dialog
        classes={{
          root: classes.center + " " + classes.modalRoot,
          paper: classes.modal,
        }}
        open={infoModal}
        TransitionComponent={Transition}
        keepMounted
        onClose={() => setInfoModal(false)}
        aria-labelledby="notice-modal-slide-title"
        aria-describedby="notice-modal-slide-description"
      >
        <DialogTitle
          id="notice-modal-slide-title"
          disableTypography
          className={classes.modalHeader}
        >
          <Button
            justIcon
            className={classes.modalCloseButton}
            key="close"
            aria-label="Close"
            color="transparent"
            onClick={() => setInfoModal(false)}
          >
            <Close className={classes.modalClose} />
          </Button>
          <h4 className={classes.modalTitle}>{name}</h4>
        </DialogTitle>
        <DialogContent
          id="notice-modal-slide-description"
          className={classes.modalBody}
        >
          <div className={classes.modalBody}>
            {image && (
              <div>
                <br></br>
                <CardAvatar profile>
                  <img src={image} />
                </CardAvatar>
                <br></br>
              </div>
            )}

            <GridContainer>
              {institution && (
                <GridContainer>
                  <GridItem xs={12} sm={12} md={12}>
                    <h4 className={classes.cardTitle}>
                      <b>Institution</b>
                    </h4>
                  </GridItem>

                  <GridItem xs={12} sm={12} md={12}>
                    <p>{institution}</p>
                  </GridItem>
                </GridContainer>
              )}

              {about && (
                <GridContainer>
                  <GridItem xs={12} sm={12} md={12}>
                    <h4 className={classes.cardTitle}>
                      <b>About Me</b>
                    </h4>
                  </GridItem>

                  <GridItem xs={12} sm={12} md={12}>
                    <p>{about}</p>
                  </GridItem>
                </GridContainer>
              )}

              {studies > 0 && (
                <GridContainer>
                  <GridItem xs={12} sm={12} md={12}>
                    <h4 className={classes.cardTitle}>
                      <b>Number of PALISI Publications</b>
                    </h4>
                  </GridItem>

                  <GridItem xs={12} sm={12} md={12}>
                    {studies}
                  </GridItem>
                  <GridItem xs={12} sm={12} md={12}>
                    <h4 className={classes.cardTitle}>
                      <b>Latest PALISI Publications</b>
                    </h4>
                  </GridItem>
                  <GridItem xs={12} sm={12} md={12}>
                    {recentStudies &&
                      recentStudies.map((study) => (
                        <li key={study}>
                          <a
                            href={
                              "https://pubmed.ncbi.nlm.nih.gov/" + study.uid
                            }
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            {study.title}
                          </a>
                        </li>
                      ))}
                  </GridItem>
                </GridContainer>
              )}
            </GridContainer>
          </div>
        </DialogContent>
        <DialogActions
          className={classes.modalFooter + " " + classes.modalFooterCenter}
        >
          <Button
            onClick={() => {
              clearData();
              setInfoModal(false);
            }}
            color="rose"
            round
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>

      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
          <Card>
            <CardBody>
              <ReactTable
                columns={[
                  {
                    Header: "Name",
                    accessor: "name",
                  },
                  {
                    Header: "Institution",
                    accessor: "institution",
                  },
                  {
                    Header: "Actions",
                    accessor: "actions",
                  },
                ]}
                initialState={{ hiddenColumns: ["type"] }}
                data={userData}
                defaultPageSize={20}
              />
            </CardBody>
          </Card>
        </GridItem>
      </GridContainer>
    </div>
  );
}

MemberDirectory.propTypes = {
  users: PropTypes.array,
  userInfo: PropTypes.object,
  members: PropTypes.array,
  images: PropTypes.array,
  studies: PropTypes.array,
  reloadUsersCallBack: PropTypes.func,
  reloadTentativesCallBack: PropTypes.func,
};
